// extracted by mini-css-extract-plugin
module.exports = {"container":"socials_container__lffGg","inputWrapper":"socials_inputWrapper__3JsKm","input":"socials_input__1GjLl","label":"socials_label__2u0X4"};